<template>
  <!-- 异常明细 -->
  <section>
    <ax-panel :noTitle="true">
      <div class="padding16">
        <div class="total-box">
          <span class="title">考勤异常明细</span>
          <span>共异常{{attendanceDays}}天</span>
        </div>
        <ul>
          <li v-for="(item,index) in attendanceList" :key="index">
            <div>
              <span class="min-title-left">
                {{item.dur}}
                <span class="type" :class="{'title-type-warn': item.qh_kaoqin_desc && item.qh_kaoqin_desc.indexOf('旷工') == -1 }">
                  <span>{{item.qh_kaoqin_desc}}</span>
                </span>
              </span>
              <span class="min-abnormal-width">
                <span class="title">异常：</span>
                {{Number(item.qh_overtime_days).toFixed(1)}}天
              </span>
            </div>
            <div>
              <span class="title">异常原因</span>
              <span>{{getAbnormalReason(item.qh_exception_rsn)}}</span>
            </div>
            <div>
              <span class="title">申请说明</span>
              <span class="comments">{{item.comments}}</span>
            </div>
          </li>
        </ul>
      </div>
    </ax-panel>
  </section>
</template>

<script>
import approval from "@/assets/js/approval/commonApproval.js";
import request from "@/utils/request";
export default {
  data() {
    return {
      attendanceList: [], // 异常数据
      attendanceDays: 0, // 异常天数
      attendanceReason: [
        {
          id: "11",
          text: '工卡失效',
        }, {
          id: "12",
          text: '闸机故障',
        }, {
          id: "13",
          text: '移动打卡故障',
        }, {
          id: "14",
          text: '忘记打卡',
        }, {
          id: "15",
          text: '新员工入职未发卡',
        },
      ],// 异常原因-后端网关配合有问题，且数据不会变更，所以暂放前端
      instanceId: this.$route.query.instanceId,
      pageId: this.$route.query.pageId,
      pageObj: {},
      detailListKey: "",
      toast: null,
    };
  },
  watch: {
    $route() {
      this.getPageId();
      this.fetchDataByPageId();
    }
  },
  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: "加载中...",
      duration: 0
    });
    this.getPageId();
    this.fetchDataByPageId();
  },
  methods: {
    // 匹配考勤异常原因id
    getAbnormalReason(id) {
      let res = '';
      this.attendanceReason.forEach((item)=>{
        if(item.id == id) {
          res = item.text
        }
      })
      return res
    },
    // 获取pageId
    getPageId() {
      this.instanceId = this.$route.query.instanceId;
      this.pageId = this.$route.query.pageId;
      this.pageObj = approval[this.pageId];
      this.detailListKey = this.pageObj.detailListKey;
    },
    // 根绝pageId 获取数据
    fetchDataByPageId() {
      if (!this.pageObj) {
        this.toast && this.toast.clear();
        this.toast = this.$toast("暂无明细");
        return;
      }
      let options = {
        url: this.pageObj.serviceUrl,
        method: this.pageObj.method
      };

      // 请求参数需要  都是从 query 里获取
      let body = {};
      this.pageObj.data.forEach(item => {
        body[item[0]] = this[item[1]];
      });
      if (this.pageObj.method === "get") {
        options.params = body;
      } else {
        options.data = body;
      }

      request(options)
        .then(({ data }) => {
          if (data.code === 200) {
            this.showResult = false;
            this.attendanceList = data.data[this.detailListKey];
            let num = 0;
            this.attendanceList.forEach((item) => {
              num = num + parseFloat(item.qh_overtime_days);
            });
            this.attendanceDays = num.toFixed(1);
          } else {
            this.toast && this.toast.clear();
            this.toast = this.$toast("暂无明细");
          }
        })
        .catch(e => {
          this.toast && this.toast.clear();
          this.toast = this.$toast("暂无明细");
        })
        .finally(_ => {
          this.toast && this.toast.clear();
        });
    }
  },
  beforeDestroy() {
    this.toast && this.toast.clear();
  }
};
</script>

<style lang="scss" scoped>
.padding16 {
  padding: 16px;
  .total-box{
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1B2532;
    font-size: 16px;
    font-family: PingFang SC;
    margin-bottom: 16px;
  }
  .title{
    color: #626F85;
  }
  ul{
    width: 100%;
    height: 100%;
    li{
      padding: 16px;
      background: #F7F9FA;
      border-radius: 8px;
      margin-bottom: 8px;
      color: #1B2532;
      font-size: 16px;
      font-family: PingFang SC;
      div{
        min-height: 30px;
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        .type{
          margin-left: 8px;
          font-size: 14px;
          border-radius: 69px;
          justify-content: center;
          align-items: center;
          padding: 0 8px;
          background: rgba(255, 77, 92, 0.10);
          color: #FF4D5C;
        }
        .title-type-warn{
          background: rgba(255, 161, 68, 0.10);
          color: #FF9900;
        }
        .comments{
          max-width: calc(100% - 100px);
        }
        .min-title-left{
          width: calc(100% - 95px);
          overflow: hidden;
          white-space: nowrap;
        }
        .min-abnormal-width{
          min-width: 95px;
        }
      }
    }
  }
}
</style>
